import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3C11.2043 3 10.4413 3.31607 9.87866 3.87868C9.31605 4.44129 8.99998 5.20435 8.99998 6C8.99998 6.79565 9.31605 7.55871 9.87866 8.12132C10.4413 8.68393 11.2043 9 12 9C12.7956 9 13.5587 8.68393 14.1213 8.12132C14.6839 7.55871 15 6.79565 15 6C15 5.20435 14.6839 4.44129 14.1213 3.87868C13.5587 3.31607 12.7956 3 12 3ZM8.818 2.81802C9.66191 1.97411 10.8065 1.5 12 1.5C13.1935 1.5 14.338 1.97411 15.182 2.81802C16.0259 3.66193 16.5 4.80653 16.5 6C16.5 7.19347 16.0259 8.33807 15.182 9.18198C14.338 10.0259 13.1935 10.5 12 10.5C10.8065 10.5 9.66191 10.0259 8.818 9.18198C7.97408 8.33807 7.49998 7.19347 7.49998 6C7.49998 4.80653 7.97408 3.66193 8.818 2.81802ZM12 13.4905C10.2289 13.4905 8.52869 14.1866 7.26614 15.4287C6.12051 16.5558 5.41849 18.0504 5.27667 19.6406C7.34198 20.5158 9.61371 21 12 21H12.001C14.3121 21.0031 16.5982 20.5401 18.7233 19.6404C18.5814 18.0503 17.8794 16.5557 16.7338 15.4287C15.4713 14.1866 13.7711 13.4905 12 13.4905ZM6.21417 14.3594C7.7573 12.8413 9.83527 11.9905 12 11.9905C14.1647 11.9905 16.2427 12.8413 17.7858 14.3594C19.3289 15.8775 20.2135 17.9413 20.2489 20.1058C20.2537 20.4034 20.0821 20.6757 19.8116 20.7997C17.3606 21.9236 14.6953 22.5037 11.999 22.5C9.21321 22.4999 6.56701 21.8916 4.18809 20.7996C3.91768 20.6755 3.74622 20.4032 3.75108 20.1058C3.78643 17.9413 4.67105 15.8775 6.21417 14.3594Z"
        fill={colorValue}
      />
    </svg>
  );
};
